import * as types from '../constants/actionTypes';

export function initState(payload) {
  return function (dispatch) {
    return dispatch({
      type: types.INIT_STATE,
      payload: payload
    });
  };
}
export function initData(payload) {
  return function (dispatch) {
    return dispatch({
      type: types.INIT_DATA,
      payload: payload
    });
  };
}
export function saveSelected(payload) {
  return function (dispatch) {
    return dispatch({
      type: types.SAVE_SELECTED,
      payload: payload
    });
  };
}

export function getSelected() {
  return { 
    type: types.GET_SELECTED
  };
}

export function restartConfigurator(){
  return function(dispatch) {
    return dispatch({
      type: types.SAVE_SELECTED
    });
  };
}

export function pushResult(payload) {
  return function (dispatch) {
    return dispatch({
      type: types.PUSH_RESULT,
      payload: payload
    });
  };
}

export function resetConfigurator(payload) {
  return function (dispatch) {
    return dispatch({
      type: types.RESET_CONFIGURATOR,
      payload: payload
    });
  };
}

export function setScrollIndicator(payload) {
  return function (dispatch) {
    return dispatch({
      type: types.SET_SCROLL_INDICATOR,
      payload
    });
  };
}

export function setLastQuestionId(payload) {
  return function (dispatch) {
    return dispatch({
      type: types.SET_LAST_QUESTION_ID,
      payload
    });
  };
}


// WEBPACK FOOTER //
// ./src/actions/index.js